/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
import { oauth2ClientsCreate } from "../funcs/oauth2ClientsCreate.js";
import { oauth2ClientsDelete } from "../funcs/oauth2ClientsDelete.js";
import { oauth2ClientsGet } from "../funcs/oauth2ClientsGet.js";
import { oauth2ClientsList } from "../funcs/oauth2ClientsList.js";
import { oauth2ClientsUpdate } from "../funcs/oauth2ClientsUpdate.js";
import { ClientSDK } from "../lib/sdks.js";
import { unwrapAsync } from "../types/fp.js";
import { unwrapResultIterator } from "../types/operations.js";
export class Clients extends ClientSDK {
    /**
     * List Clients
     *
     * @remarks
     * List OAuth2 clients.
     */
    async list(request, options) {
        return unwrapResultIterator(oauth2ClientsList(this, request, options));
    }
    /**
     * Create Client
     *
     * @remarks
     * Create an OAuth2 client.
     */
    async create(request, options) {
        return unwrapAsync(oauth2ClientsCreate(this, request, options));
    }
    /**
     * Get Client
     *
     * @remarks
     * Get an OAuth2 client by Client ID.
     */
    async get(request, options) {
        return unwrapAsync(oauth2ClientsGet(this, request, options));
    }
    /**
     * Update Client
     *
     * @remarks
     * Update an OAuth2 client.
     */
    async update(request, options) {
        return unwrapAsync(oauth2ClientsUpdate(this, request, options));
    }
    /**
     * Delete Client
     *
     * @remarks
     * Delete an OAuth2 client.
     */
    async delete(request, options) {
        return unwrapAsync(oauth2ClientsDelete(this, request, options));
    }
}
//# sourceMappingURL=clients.js.map